// extracted by mini-css-extract-plugin
export default {"main":"PostIdMain_main__nbSYB","beige":"PostIdMain_beige__Erfgd","purple":"PostIdMain_purple__BKYMI","blue":"PostIdMain_blue__Gr9LO","green":"PostIdMain_green__b2x+u"};